// 时间日期
export function yeartime(date) {
  let date_ = new Date(parseInt(date) * 1000);
  const year = date_.getFullYear()
  const month = date_.getMonth() + 1
  const day = date_.getDate()
  const hour = date_.getHours()
  const minute = date_.getMinutes()
  const second = date_.getSeconds()

  return year + '/' + month + '/' + day
}

export function yeartime_(date_) {
  const year = date_.getFullYear()
  const month = date_.getMonth() + 1
  const day = date_.getDate()
  const hour = date_.getHours()
  const minute = date_.getMinutes()
  const second = date_.getSeconds()

  return year + '-' + month + '-' + day
}

export function yeartime_day(dateIn) {
  let date = ''
  let date_ = ''
  if (dateIn) {
    date = dateIn.toString();
    date_ = new Date(parseInt(dateIn));
    if (date.length === 10) {
      date_ = new Date(parseInt(dateIn) * 1000);
    }
  } else {
    date_ = new Date()
  }

  const year = date_.getFullYear()
  let month = date_.getMonth() + 1
  let day = date_.getDate()
  let hour = date_.getHours()
  let minute = date_.getMinutes()
  // const second = date_.getSeconds()
  month = month < 10 ? ('0' + month) : month;
  day = day < 10 ? ('0' + day) : day;
  hour = hour < 10 ? ('0' + hour) : hour;
  minute = minute < 10 ? ('0' + minute) : minute;
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute
}

export function yearDatetime(date_) {
  const year = date_.getFullYear()
  const month = date_.getMonth() + 1
  const day = date_.getDate()
  const hour = date_.getHours()
  const minute = date_.getMinutes()
  const second = date_.getSeconds()

  return year + '/' + month + '/' + day
}
